export default "__VITE_ASSET__DNMbRSfo__"